/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from '@material-ui/core';
import SimpleModal from '../../../../../../../components/SimpleModal/SimpleModal';
import Button from '../../../../../../../components/Basic/Button';
import FiltersList from './FiltersList';
import { useActiveValueCount } from '../Count';

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiDialogActions-root button:first-child': {
      minWidth: '64px',
    },

    '& .MuiDialogContent-root': {
      overflow: 'hidden',
    },

    '& .MuiDialogTitle-root': {
      '& h2.MuiTypography-root': {
        fontSize: '1.05rem',
        fontWeight: 500,
      },
    },

    '& .SearchPanel': {
      marginBottom: 14,
    },

    '& section': {
      paddingBottom: 16,
      maxHeight: 400,
      minWidth: 220,
      overflow: 'auto',
      overflowX: 'hidden',
      overflowY: 'auto',

      '& ul': {
        margin: 0,
        padding: 0,
      },
    },
  },
  closeButton: {
    position: 'absolute',
    top: 8,
    right: 8,

    '& .MuiSvgIcon-root': {
      fontSize: '1.3rem',
    },
  },
}));

const ViewActiveModal = ({
  open = false,
  onClose,
  onConfirm,
  disabled = false,
  className = '',
}) => {
  const classes = useStyles();
  const count = useActiveValueCount();

  return (
    <SimpleModal
      open={open}
      onClose={onClose}
      className={`ViewActiveModal ${classes.root} ${className}`}
      onClick={(evt) => evt.stopPropagation()}
      title={
        <div>
          Filters applied ({count}) :
          <IconButton className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>
      }
      controlChildren={
        <div>
          <Button
            onClick={onConfirm}
            disabled={disabled}
            color="primary"
            variant="contained"
          >
            Clear all filters
          </Button>
          <Button color="primary" onClick={onClose}>
            Ok
          </Button>
        </div>
      }
    >
      <section>
        <FiltersList />
      </section>
    </SimpleModal>
  );
};

export default ViewActiveModal;
